var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{ref:"popup",attrs:{"disabled":_vm.disabled,"limit":_vm.limit,"max":_vm.max},on:{"confirm":_vm.handleConfirm,"close":_vm.handleClose},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}},[(_vm.url)?_vm._t("preview",null,{"url":_vm.url,"index":_vm.index}):_vm._t("upload")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }